import { makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import QuoteIOSSwitch from "../switch.component";

import {
  offers as LBOffers,
  installments,
} from "../../../utils/bot-calculations";
import { currencies } from "../../currencies/currencies";

export default function QuotePriceBlock(props) {
  const [state] = useState(props);

  let currentCurrency = "$";
  const currency = currencies?.find(
    (currency) => currency.name === props.currency,
  );
  if (currency) {
    currentCurrency = currency.symbol;
  }

  const useStyles = makeStyles((theme) => ({
    blockContainer: {
      display: "flex",
      flexDirection: "row",
      width: "90%",
      maxWidth: "100%",
      minHeigth: 78,
      background: "#DBF3FF",
      borderRadius: 10,
      border: "1px solid #3597EC",
      paddingTop: 15,
      paddingLeft: 15,
      marginBottom: 20,
      marginLeft: "auto",
      marginRight: "auto",
      boxSizing: "border-box",
      fontFamily: `'Open Sans', sans-serif`,
    },
    unselectedBlockContainer: {
      display: "flex",
      flexDirection: "row",
      width: "90%",
      maxWidth: "100%",
      background: "#FFF",
      borderRadius: 10,
      border: "1px solid #3597EC",
      paddingTop: 15,
      paddingLeft: 15,
      marginBottom: 20,
      marginLeft: "auto",
      marginRight: "auto",
      boxSizing: "border-box",
    },
    serviceBlock: {
      display: "flex",
      flexDirection: "column",
      paddingRight: 10,
      minWidth: "70%",
    },
    priceBlock: {
      display: "flex",
      flexDirection: "column",
      paddingRight: 10,
      minWidth: "25%",
    },
    boldServiceText: {
      fontFamily: `'Open Sans', sans-serif`,
      fontSize: 18,
      textTransform: "uppercase",
      fontWeight: 700,
    },
    disabledServiceText: {
      fontFamily: `'Open Sans', sans-serif`,
      fontSize: 18,
      color: "#707070",
      fontWeight: 700,
    },
    serviceDescription: {
      fontSize: 11,
      marginBottom: 20,
    },
    perVisit: {
      fontSize: 12,
      color: "#393b3a",
      lineHeight: 1,
    },
  }));

  const classes = useStyles();

  const hasOffers = !!props.offers.filter((i) => !i.hide).length;
  let offerText = "";
  let offer = {};

  let firstDisplay;

  const filterFirstLabel = (label) => {
    if (label.trim() === "1st") {
      return "";
    }

    return label;
  };

  const displayLabel =
    props.applicationLabel.charAt(0).toUpperCase() +
    props.applicationLabel.slice(1);

  /* this is the new lawnbot pricing calculation stuff */
  const services = props.services
    ? props.term === "total"
      ? props.services.prePay
      : props.services.application
    : [];
  const applications =
    services && Array.isArray(services)
      ? services.filter((s) => !s.tooLateToDo).length
      : [];

  const usesUpfrontPricing =
    props.services.application[0].usesUpfrontPricing || false;

  // Use pre-calculated pricing from server
  const termPricing =
    props.term === "total"
      ? props.calculatedPricing?.total
      : props.calculatedPricing?.application;
  firstDisplay = termPricing?.displayPrice ?? 0;

  if (usesUpfrontPricing && props.term === "total") {
    if (!firstDisplay) {
      const upfront = props.services.application[0].grossPrice;
      const recurring = props.services.application[0].recurringPrice;
      firstDisplay = upfront + props.services?.prePay?.length * recurring;
    }
  }

  offer = props.offers[0];
  offerText = props.hideDiscountText
    ? ""
    : props.realTime
      ? LBOffers.createRTPText(
          props.services[props.term === "total" ? "prePay" : "application"],
          currentCurrency,
          props.term === "total",
        )
      : hasOffers
        ? LBOffers.createOfferText(
            props.services[props.term === "total" ? "prePay" : "application"][0]
              .grossPrice,
            offer,
            props.applicationLabel,
            currentCurrency,
          )
        : props.term === "total" && props.prePayDiscount
          ? `${props.prePayDiscount}% off for pre-paying`
          : "";

  // console.log(props)

  const labels = installments.getInstallmentsLabels(
    props.autoPayPriceMethod,
    props.autoPayMonthlyPricePeriod,
    props.applicationLabel,
    props.autoPayAlternativeLabel,
  );

  if (usesUpfrontPricing) {
    labels.switchLabel = LBOffers.createRTPText(
      props.services.application,
    ).replace(
      "per month",
      `per ${props.alternativePaymentVerbiage || "installment"}`,
    );
  }

  /* end new lawnbot pricing calculation stuff */
  return (
    <div
      className={
        props.selected
          ? classes.blockContainer
          : classes.unselectedBlockContainer
      }
    >
      <div
        className={
          props.selected
            ? classes.serviceBlock
            : `${classes.disabledServiceText} ${classes.serviceBlock}`
        }
      >
        <div className={classes.boldServiceText}>
          {props.serviceName || "WEEKLY MOWING"}
        </div>
        <div className={classes.serviceDescription}>
          {props.serviceDescription ||
            `Cutting, edging & blowing off all hard 
surfaces every 7-10 days`}
          <br />
          <br />
          {!usesUpfrontPricing || (props.seasonalText && usesUpfrontPricing) ? (
            <span style={{ fontWeight: "bold", fontSize: 13 }}>
              {displayLabel.trim() ? `${applications}` : ""} {displayLabel}
              {displayLabel.trim() && applications > 1 ? "s" : ""}{" "}
              {props.seasonalText}
            </span>
          ) : null}
        </div>
      </div>
      <div className={classes.priceBlock}>
        <div
          className={
            props.selected
              ? classes.boldServiceText
              : classes.disabledServiceText
          }
        >
          {currentCurrency}
          {firstDisplay ? firstDisplay.toFixed(2) : "0"}
        </div>
        <div className={classes.perVisit}>
          {props.term === "total"
            ? "total"
            : filterFirstLabel(labels.switchLabel)}
        </div>
        <QuoteIOSSwitch {...state} />
        <p
          style={{
            fontSize: 10,
            fontWeight: "bold",
            color: "red",
          }}
        >
          {offerText}
        </p>
      </div>
    </div>
  );
}
